export default "__VITE_ASSET__Cfbv9ast__"